export const CURRENCY_LIST_FETCH_START = 'CURRENCY_LIST_FETCH_START';
export const CURRENCY_LIST_FETCH_SUCCESS = 'CURRENCY_LIST_FETCH_SUCCESS';
export const CURRENCY_LIST_FETCH_FAILURE = 'CURRENCY_LIST_FETCH_FAILURE';
export const GET_WEEKLY_BILLING = 'GET_WEEKLY_BILLING';
